import { set } from "./storage";
import { USER_TOKEN } from "../constants";

export const removeToken = () => {
  set(USER_TOKEN, null);
};
